<template>
  <v-app>
    <v-app-bar app flat color="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pt-14">
      <div class="container1400">
        <v-container fluid>
          <h1 class="text-h5 font-weight-medium mt-5 mb-5">
            {{ $t("CancelBookingTitle") }}
          </h1>
          <v-alert dense outlined type="error" v-if="error">
            <ul>
              <li v-for="item in error" :key="item.msg">
                {{ $t(item.msg) }}
              </li>
            </ul>
          </v-alert>
          <v-skeleton-loader
            v-if="loading"
            type="article"
            class="mt-10"
          ></v-skeleton-loader>
          <div v-if="list">
            <div v-if="list.property_id">
              <v-card height="100%" elevation="0" class="pa-5">
                <v-row>
                  <v-col md="6" cols="12">
                    <h2 class="text-h5 mt-5">
                      {{ list.property_id.name }}
                    </h2>
                    <div class="pb-5 text-capitalize">
                      <span>
                        <v-icon small class="gray--text"
                          >mdi-map-marker-radius</v-icon
                        >
                        {{ list.property_id.location }}
                      </span>
                    </div>
                    <h2 class="text-h6 pb-2">{{ $t("TripDetails") }}</h2>
                    <v-row>
                      <v-col cols="4">
                        <div class="overline grey--text">
                          {{ $t("TripStatus") }}
                        </div>
                        <div class="subtitle-2 mb-3">
                          {{ $t(list.booking_status) }}
                        </div>
                        <div class="overline grey--text">
                          {{ $t("Tripid") }}
                        </div>
                        <div class="subtitle-2 mb-3">
                          {{ $t(list._id) }}
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="overline grey--text">
                          {{ $t("Checkin") }}
                        </div>
                        <div class="subtitle-2 mb-3">
                          {{
                            format(
                              new Date(
                                list.booking_details.dates[0] + "T00:00"
                              ),
                              "eee, do MMM, yyyy"
                            )
                          }}
                          - {{ list.booking_details.check_in_time }}
                        </div>
                        <div class="overline grey--text">
                          {{ $t("Checkout") }}
                        </div>
                        <div class="subtitle-2 mb-3">
                          {{
                            format(
                              new Date(
                                list.booking_details.dates[1] + "T00:00"
                              ),
                              "eee, do MMM, yyyy"
                            )
                          }}
                          - {{ list.booking_details.check_out_time }}
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="overline grey--text">
                          {{ $t("BookedFor") }}
                        </div>
                        <div class="subtitle-2">
                          {{ list.booking_details.no_days }}
                          {{ $t("Nights") }}
                        </div>
                      </v-col>
                    </v-row>
                    <h2 class="text-h6 mt-5 pb-5">
                      {{ $t("Paymentdetails") }}
                    </h2>
                    <v-sheet
                      class="text-center pa-3 mb-5"
                      color="grey lighten-4"
                    >
                      <v-simple-table class="grey lighten-4">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left"></th>
                              <th class="text-left">
                                {{ $t("BookingAmount") }}
                              </th>
                              <th class="text-left">{{ $t("Fees") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, i) in list.payments" :key="i">
                              <td class="text-left">
                                {{ $t(item.payment_type) }}
                              </td>
                              <td class="text-left">
                                {{
                                  currencyConversion(
                                    item.amount,
                                    item.currency_code
                                  )
                                }}
                              </td>
                              <td class="text-left">
                                {{ calculateNomadCleaningFee(item) }}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colspan="2"
                                class="text-right font-weight-bold"
                              >
                                {{ $t("s1655240821") }}
                              </td>
                              <td class="text-left font-weight-bold">
                                {{ calculateTotalAmount(list.payments) }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-sheet>
                  </v-col>
                  <v-col md="6" cols="12" class="pl-10">
                    <h2 class="text-h6 mt-7 mb-3">
                      {{ $t("CP") }}
                    </h2>
                    <v-row>
                      <v-col cols="12">
                        <div class="overline grey--text">
                          {{ $t("PM61") }}
                        </div>
                        <div class="subtitle-2">
                          {{ $t("BufferPeriod") }}:
                          {{ list.property_id.short_term_buffer * 3 }}
                          {{ $t("Days") }}
                        </div>
                        <div class="overline grey--text pt-4">
                          {{ $t("PM71") }}
                        </div>
                        <div class="subtitle-2">
                          {{ $t("BufferPeriod") }}:
                          {{ list.property_id.long_term_buffer * 15 }}
                          {{ $t("Days") }}
                        </div>
                        <div class="subtitle-2 pt-4 red--text">
                          {{ $t("PM8") }}
                        </div>
                        <div>
                          <a
                            target="_blank"
                            href="https://member.nomadrooms.com/terms/cancellation/"
                            @click.stop
                          >
                            {{ $t("CP1") }}
                          </a>
                        </div>
                      </v-col>
                    </v-row>
                    <h2 class="text-h6 mt-7 pb-5">
                      {{ $t("CBmsg2") }}
                    </h2>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea
                            dense
                            outlined
                            v-model="reason"
                            :rules="reqRules"
                            :label="$t('CancelReason')"
                            rows="3"
                            hide-details="auto"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <v-btn color="red" dark @click="cancelBooking">
                            {{ $t("RequestCancellation") }}
                          </v-btn>
                          <v-btn
                            color="light-blue"
                            text
                            :to="{
                              name: 'ViewBooking',
                              params: { id: parm }
                            }"
                          >
                            {{ $t("Nevermind") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import priceMixin from "@/mixins/priceMixin.js";
import { format } from "date-fns";
import CancelService from "@/services/CancelService";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import swal from "sweetalert";

export default {
  name: "CancelBookingRequest",
  mixins: [timeoutMixin, priceMixin],
  components: {
    FullHeaderComponent,
    CopyrightComponent
  },
  data() {
    return {
      format,
      list: null,
      error: null,
      valid: false,
      dialog: false,
      loading: true,
      reason: "",
      parm: this.$route.params.id,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  created: function() {
    CancelService.viewBooking({
      id: this.parm
    })
      .then(async result => {
        this.list = result.data.list;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.errors;
      });
  },
  methods: {
    async cancelBooking() {
      await this.$refs.form.validate();
      if (this.valid) {
        swal({
          text: this.$t("s1657909326"),
          className: "custom-confirm",
          buttons: {
            confirm: this.$t("Cancel"),
            cancel: this.$t("Nevermind")
          }
        }).then(value => {
          if (value) {
            this.loading = true;
            CancelService.cancelBooking({
              id: this.list._id,
              type: this.list.pay_type,
              reason: this.reason
            })
              .then(() => {
                this.$router.push({
                  name: "ViewBooking",
                  params: { id: this.list._id }
                });
              })
              .catch(err => {
                this.loading = false;
                this.error = err.response.data.errors;
              });
          }
        });
      }
    }
  }
};
</script>

<style></style>
